const EMOJI_REGEX =
  /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|\uD83E[\uDD00-\uDFFF])/g

// NFC composes accented characters (e.g. ä, ö, ü) into their precomposed form.
// NFKD was previously used here but it *decomposes* them into base letter +
// combining diacritic, which Troika's 3D cover fonts fail to render — see COR-1040.
export const normalizeText = (str: string): string =>
  str.normalize('NFC').replace(EMOJI_REGEX, '')

/**
 * Validates if a value is a non-empty string after trimming whitespace
 * @param value - The value to validate
 * @returns true if the value is a valid non-empty string, false otherwise
 */
export function isNonEmptyString(value: unknown): value is string {
  return typeof value === 'string' && value.trim().length > 0
}
